import { useEffect, useMemo, useState } from 'react'

export interface Countdown {
  hours: string
  minutes: string
  seconds: string
  expired: boolean
}

const pad = (value: number): string => String(Math.max(value, 0)).padStart(2, '0')

/**
 * Counts down from a fixed number of hours set when the visitor arrives.
 */
export function useCountdown(hoursFromNow: number): Countdown {
  const deadline = useMemo(
    () => Date.now() + hoursFromNow * 60 * 60 * 1000,
    [hoursFromNow],
  )
  const [remaining, setRemaining] = useState(() => deadline - Date.now())

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(deadline - Date.now())
    }, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.max(Math.floor(remaining / 1000), 0)

  return {
    hours: pad(Math.floor(totalSeconds / 3600)),
    minutes: pad(Math.floor((totalSeconds % 3600) / 60)),
    seconds: pad(totalSeconds % 60),
    expired: totalSeconds === 0,
  }
}
